// src/components/RoomSelector.jsx
import React, { useState, useEffect } from 'react';
import { fetchRooms, getRoomAvailability } from '../../services/roomService';

const RoomSelector = ({ accessToken, startTime, endTime, onRoomSelect }) => {
    const [rooms, setRooms] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    
    useEffect(() => {
        const loadRooms = async () => {
            try {
                setLoading(true);
                const fetchedRooms = await fetchRooms(accessToken);
        

                const mappedRooms = fetchedRooms.map(room => ({
                    id: room.address,
                    displayName: room.name,
                    emailAddress: room.address
                }));

                setRooms(mappedRooms || []);

                setError(null);
            
            } catch (err) {
                console.error('Error loading rooms:', err);
                setError('Failed to load rooms. Please try again later.');
                setRooms([]);
            } finally {
                setLoading(false);
            }
        };

        if (accessToken) {
            loadRooms();
        }
    }, [accessToken]);

    const handleRoomChange = async (e) => {
        const selectedRoomId = e.target.value;
        if (!selectedRoomId) {
            onRoomSelect(null);
            return;
        }

        const selectedRoom = rooms.find(room => room.id === selectedRoomId);
        if (selectedRoom) {
            const isAvailable = await getRoomAvailability(
                accessToken,
                selectedRoom.emailAddress,
                startTime,
                endTime
            );

            if (isAvailable) {
                onRoomSelect(selectedRoom);
            } else {
                alert('This room is not available for the selected time slot.');
                e.target.value = ''; // Reset selection
                onRoomSelect(null);
            }
        }
    };

    if (loading) {
        return <div>Loading rooms...</div>;
    }

    if (error) {
        return <div style={{ color: 'red' }}>{error}</div>;
    }

    return (
        <div>
            <label htmlFor="room-select">Meeting Room (Optional)</label>
            <select
                id="room-select"
                onChange={handleRoomChange}
                defaultValue=""
            >
                <option value="">-- Select a room --</option>
                {rooms.map((room) => (
                    <option key={room.id} value={room.id}>
                        {room.displayName || room.emailAddress}
                    </option>
                ))}
            </select>
            {rooms.length === 0 && !loading && (
                <p style={{ color: 'gray', fontSize: '0.9em' }}>
                    No rooms available in your organization
                </p>
            )}
        </div>
    );
};

export default RoomSelector;